import { render, staticRenderFns } from "./RecentQuery.vue?vue&type=template&id=50928685"
import script from "./RecentQuery.vue?vue&type=script&lang=js"
export * from "./RecentQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports